module.exports = __webpack_public_path__ + "img/failed_courses.05038b48.svg";